// extracted by mini-css-extract-plugin
module.exports = {"personalCenter":"PersonalCenter_personalCenter__wxe5y"};